import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8","key":"svg-0"}],["path",{"d":"M9 18h2","key":"svg-1"}],["path",{"d":"M20 21l2 -2l-2 -2","key":"svg-2"}],["path",{"d":"M17 17l-2 2l2 2","key":"svg-3"}]]

const IconDeviceIpadCode = createReactComponent('outline', 'device-ipad-code', 'DeviceIpadCode', __iconNode);

export default IconDeviceIpadCode;